import React, { useEffect, useRef } from 'react';

const Gallery = () => {
  const photos = [
    '/gallery/madrid_1.jpg',
    '/gallery/la_nau_2.jpg',
    '/gallery/vuelo_despierto_1.jpg',
    '/gallery/la_nau_1.jpg',
    // Add more photo paths as needed
  ];

  const galleryRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.animationDelay = `${entry.target.dataset.index * 0.1}s`;
            entry.target.style.animationPlayState = 'running';
          }
        });
      },
      {
        threshold: 0.1
      }
    );

    const galleryItems = galleryRef.current.querySelectorAll('.gallery-item img');
    galleryItems.forEach((item, index) => {
      item.style.animationPlayState = 'paused';
      item.dataset.index = index;
      observer.observe(item);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="gallery-section" ref={galleryRef}>
      {photos.map((photo, index) => (
        <div className="gallery-item" key={index}>
          <img 
            src={photo} 
            alt={`Gallery photo ${index + 1}`}
            style={{ '--delay': index }}
          />
        </div>
      ))}
    </div>
  );
};

export default Gallery; 